import React, { useState } from "react";
import InputField from "../../admin/childComponents/inputComponents/InputField";
import TextArea from "../../admin/childComponents/inputComponents/TextArea";
import CAPTCHATurnStile from "../../admin/childComponents/appComponents/CAPTCHATurnStile";
import axios from "axios";
import swal from "sweetalert";
import Loading from "../../admin/childComponents/appComponents/Loading";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ContactSection(props) {
  const [loading, setLoading] = useState(false);
  const [reCaptcha, setReCaptcha] = useState(false);
  const [formData, setFormData] = useState({
    input: {
      names: "",
      email: "",
      mobile: "",
      subject: "",
    },
    textArea: {
      textMessage: "",
    },
  });

  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  const refreshScreen = () => {
    setFormData({
      input: {
        names: "",
        email: "",
        mobile: "",
        subject: "",
      },
      textArea: {
        textMessage: "",
      },
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    //const subject = "Thank You for Reaching Out";
    const formPayload = new FormData();
    formPayload.append("names", formData.input.names);
    formPayload.append("email", formData.input.email);
    formPayload.append("mobile", formData.input.mobile);
    formPayload.append("subject", formData.input.subject);
    formPayload.append("textMessage", formData.textArea.textMessage);
    //formPayload.append("subject", subject);
    formPayload.append("typeRequest", "FOI");

    try {
      await axios.get("/sanctum/csrf-cookie");
      const res = await axios.post(`${BASE_URL}fbdata`, formPayload);
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        refreshScreen();
      } else {
        swal("Error", res.data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to send message", "error");
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loading message01="Loading..." />;
  return (
    <section id="contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>
          <span>Have Questions?</span>{" "}
          <span className="description-title">Contact Us</span>
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay={100}>
        <div className="row gy-4">
          {/* Left Info Panel */}
          <div className="col-lg-5">
            <div className="info-wrap">
              <div
                className="info-item d-flex"
                data-aos="fade-up"
                data-aos-delay={200}
              >
                <i className="fa fa-map-marker-alt flex-shrink-0" />
                <div>
                  <h3>Address</h3>
                  <p>FEDERAL MINISTRY OF HOUSING AND URBAN DEVELOPMENT</p>
                  <p>Headquarters, Mabushi, Abuja</p>
                </div>
              </div>
              <div
                className="info-item d-flex"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <i className="fa-solid fa-phone flex-shrink-0" />
                <div>
                  <h3>Call Us</h3>
                  <p>Nigeria: 234-(0)- 8 061 7433 13</p>
                  <p>Call Time: 8 - 4pm Daily, Monday to Friday</p>
                </div>
              </div>
              <div
                className="info-item d-flex"
                data-aos="fade-up"
                data-aos-delay={400}
              >
                <i className="fa-solid fa-envelope flex-shrink-0" />
                <div>
                  <h3>Email Us</h3>
                  <p>Enquiries: info@fmhud.gov.ng </p>
                  <p>Minister Registry: hmregistry@fmhud.gov.ng </p>
                  <p>Minister of State: hmsregistry@fmhud.gov.ng </p>
                  <p>Permanent Sec: psregistry@fmhud.gov.ng</p>
                </div>
              </div>

              <iframe
                title="Google Map Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3939.8214274164316!2d7.453387!3d9.080027!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b0051bb9dff%3A0xb06406a0d062ec36!2sFederal%20Ministry%20of%20Housing%20and%20Urban%20Development!5e0!3m2!1sen!2sng!4v1777032230675!5m2!1sen!2sng"
                frameBorder={0}
                style={{ border: 0, width: "100%", height: 270 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-7">
            <form
              onSubmit={handleSubmit}
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="row gy-4">
                <div className="col-md-12">
                  <InputField
                    label="Your Names"
                    name="names"
                    size="14"
                    required="required"
                    value={formData.input.names}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Email"
                    name="email"
                    size="14"
                    required="required"
                    value={formData.input.email}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Phone Number"
                    name="mobile"
                    size="14"
                    required="required"
                    value={formData.input.mobile}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-12">
                  <InputField
                    label="Subject"
                    name="subject"
                    size="14"
                    required="required"
                    value={formData.input.subject}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="col-md-12">
                  <TextArea
                    label="Message"
                    name="textMessage"
                    size="14"
                    rows={7}
                    required="required"
                    value={formData.textArea.textMessage}
                    onChange={updateFormData}
                  />
                </div>
                <div className="form-group">
                  <CAPTCHATurnStile
                    reCaptcha={reCaptcha}
                    setReCaptcha={setReCaptcha}
                  />
                </div>
                <div className="col-md-12 text-center">
                  {loading ? (
                    <Loading message01="Sending message..." />
                  ) : (
                    <button type="submit" disabled={!reCaptcha}>
                      Send Message
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(ContactSection);
